import PropTypes from "prop-types";

export const IconDropdownModel = {
    id: PropTypes.number,
    name: PropTypes.string,
    icon: PropTypes.string,
    hoverIcon: PropTypes.string,
    isSelected: PropTypes.bool
};
